<template>
  <div class="page">
    <!-- 导航栏 -->
    <div class="nav">
      <h1>体检报告查询</h1>
    </div>

    <!-- 主内容区 -->
    <div class="main">
      <!-- 添加标题 -->
      <div class="page-title">
        <h2>青少年脊柱侧弯筛查报告查询</h2>
      </div>

      <!-- 搜索表单 -->
      <div class="search-form">
        <!-- 学校选择 -->
        <div class="form-item">
          <div class="select-input" @click="showSchoolSelector = true">
            <span :class="{ 'placeholder': !schoolName }">
              {{ schoolName || '请选择学校' }}
            </span>
            <i class="arrow-down"></i>
          </div>
        </div>

        <!-- 班级选择 -->
        <div class="form-item">
          <div class="select-input" :class="{ 'select-input-disabled': !schoolName }" @click="handleGradeClick">
            <span :class="{ 'placeholder': !grade }">
              {{ grade || '请选择班级' }}
            </span>
            <i class="arrow-down"></i>
          </div>
        </div>

        <!-- 姓名输入框 -->
        <div class="form-item">
          <input v-model="name" type="text" placeholder="请输入学生姓名">
          <span v-if="name" class="clear-btn" @click="name = ''">×</span>
        </div>

        <!-- 学号输入框 -->
        <div class="form-item">
          <input v-model="studentId" type="text" placeholder="请输入学号(1xxxxx)">
          <span v-if="studentId" class="clear-btn" @click="studentId = ''">×</span>
        </div>

        <!-- 搜索按钮 -->
        <button class="search-btn" :class="{ 'search-btn-disabled': !name }" :disabled="!name" @click="handleSearch">
          搜索
        </button>
      </div>

      <!-- 列表区域 -->
      <div class="report-list">
        <div v-for="report in reports" :key="report.examinationRecordId" class="report-item"
          :class="{ 'report-item-disabled': report.screeningStatus === 'not_screened' }"
          @click="report.screeningStatus !== 'not_screened' && goToDetail(report.examinationRecordId)">
          <div class="report-header">
            <span class="report-id">报告编号：{{ report.examinationRecordId }}</span>
            <span class="report-type" :class="{ 'report-type-disabled': report.screeningStatus === 'not_screened' }">
              {{ report.screeningStatus === 'not_screened' ? '未筛查' : '脊柱筛查报告' }}
            </span>
          </div>
          <div class="report-content">
            <span class="report-name">{{ report.name }}</span>
            <span class="report-date">{{ formatTimestamp(report.createdTime) }}</span>
          </div>
        </div>

        <!-- 空状态 -->
        <div v-if="!reports.length && hasSearched" class="empty-state">
          <p>暂无体检报告数据</p>
        </div>
      </div>
    </div>

    <!-- 底部技术支持 - 移到page容器内的最后 -->
    <div class="footer">
      <p>技术支持：数动云医（北京）科技有限公司</p>
    </div>

    <!-- 学校选择弹窗 -->
    <div v-if="showSchoolSelector" class="selector-mask" @click="showSchoolSelector = false">
      <div class="selector-content" @click.stop>
        <div class="selector-header">选择学校</div>
        <div class="selector-list">
          <div v-for="plan in plans" :key="plan.examinationPlanId" class="selector-item"
            @click="selectSchool(plan.schoolName)">
            {{ plan.schoolName }}
          </div>
        </div>
        <div class="selector-footer">
          <button @click="showSchoolSelector = false">取消</button>
        </div>
      </div>
    </div>

    <!-- 班级选择弹窗 -->
    <div v-if="showGradeSelector" class="selector-mask" @click="showGradeSelector = false">
      <div class="selector-content" @click.stop>
        <div class="selector-header">选择班级</div>
        <div class="selector-list">
          <div v-for="grade in currentGrades" :key="grade" class="selector-item" @click="selectGrade(grade)">
            {{ grade }}
          </div>
        </div>
        <div class="selector-footer">
          <button @click="showGradeSelector = false">取消</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      schoolName: '',
      grade: '',
      name: '',
      studentId: '',
      hasSearched: false,
      reports: [],
      institutionId: '',
      plans: [],
      showSchoolSelector: false,
      showGradeSelector: false,
    }
  },
  created() {
    this.institutionId = this.$route.query.institutionId
  },
  mounted() {
    this.requestPlanList()
  },
  computed: {
    currentGrades() {
      const currentPlan = this.plans.find(plan => plan.schoolName === this.schoolName)
      if (!currentPlan) return []
      try {
        return JSON.parse(currentPlan.classAndGrade)
      } catch (e) {
        return []
      }
    }
  },
  methods: {
    //请求体检计划列表
    requestPlanList() {
      let params = {

      }
      console.log("===================", this.institutionId)
      this.$http.reqM2Service(this.$API_URL.planAll + "?institutionId=" + this.institutionId, params, 'POST')
        .then(res => {
          console.log("===================", res)
          if (res.code === 0) {
            this.plans = res.plans
          }
        })
        .catch(err => {
          console.log(err)
        })
    },

    //请求体检报告列表
    requestReportList() {
      let params = {
        "institutionId": this.institutionId,
        "schoolName": this.schoolName,
        "className": this.grade,
        "studentName": this.name,
        "studentNumber": this.studentId
      }
      this.$http.reqM2Service(this.$API_URL.queryRecordsByConditions, params, 'POST')
        .then(res => {
          console.log(res)
          if (res.code === 0) {
            this.reports = res.records
          }
        })
        .catch(err => {

        })
    },
    handleSearch() {
      if (!this.name) return
      this.hasSearched = true;
      this.requestReportList();
    },
    goToDetail(id) {
      // 跳转到详情页面
      console.log('跳转到报告详情:', id)
      this.$router.push({
        path: '/report',
        query: {
          recordId: id,
          sspType: 'SSP100'
        }
      })
    },
    // 原生格式化时间戳的方法
    formatTimestamp(timestamp) {
      if (!timestamp) return ''

      const date = new Date(timestamp)
      const Y = date.getFullYear()
      const M = String(date.getMonth() + 1).padStart(2, '0')  // 月份从0开始
      const D = String(date.getDate()).padStart(2, '0')
      const h = String(date.getHours()).padStart(2, '0')
      const m = String(date.getMinutes()).padStart(2, '0')

      return `${Y}-${M}-${D} ${h}:${m}`
    },
    selectSchool(school) {
      this.schoolName = school
      this.grade = '' // 清空班级选择
      this.showSchoolSelector = false
    },

    selectGrade(grade) {
      this.grade = grade
      this.showGradeSelector = false
    },
    handleGradeClick() {
      if (!this.schoolName) {
        // 可以添加提示，比如使用 Toast
        return
      }
      this.showGradeSelector = true
    },
  }
}
</script>

<style scoped>
.page {
  min-height: 100vh;
  background: #F5F7FA;
  width: 100vw;
  overflow-x: hidden;
  position: relative;
  /* 添加相对定位 */
}

.nav {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  /* 修改为width */
  height: 48px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #EBEEF5;
  z-index: 100;
}

.nav h1 {
  font-size: 17px;
  font-weight: 500;
  color: #1D2129;
}

.main {
  padding-top: 48px;
  width: 100%;
  box-sizing: border-box;
  padding-left: 16px;
  /* 添加左边距 */
  padding-right: 16px;
  /* 添加右边距 */
}

.search-form {
  margin-top: 32px;
  padding: 16px;
  background: #fff;
  border-radius: 8px;
}

.form-item {
  position: relative;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
}

.form-item:last-child {
  margin-bottom: 0;
}

.form-item input {
  width: 100%;
  height: 44px;
  padding: 0 12px;
  background: #F5F7FA;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  color: #1D2129;
  box-sizing: border-box;
}

.form-item input::placeholder {
  color: #86909C;
}

.clear-btn {
  position: absolute;
  right: 12px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #86909C;
  font-size: 16px;
  cursor: pointer;
  padding: 0;
  background: transparent;
  border: none;
}

.search-btn {
  width: 100%;
  height: 44px;
  background: #4080FF;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  margin-top: 16px;
}

.report-list {
  margin-top: 12px;
  margin-bottom: 16px;
}

.report-item {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
  cursor: pointer;
}

.report-item-disabled {
  cursor: not-allowed;
  opacity: 0.8;
}

.report-item:last-child {
  margin-bottom: 0;
}

.report-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.report-id {
  font-size: 14px;
  color: #86909C;
}

.report-type {
  font-size: 14px;
  color: #4080FF;
}

.report-type-disabled {
  color: #86909C;
}

.report-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.report-name {
  font-size: 16px;
  color: #1D2129;
}

.report-date {
  font-size: 14px;
  color: #86909C;
}

.empty-state {
  padding: 48px 0;
  text-align: center;
  color: #86909C;
  font-size: 14px;
}

/* 移除年级选择器相关样式，其他样式保持不变 */
.grade-selector-mask,
.grade-selector,
.grade-header,
.grade-list,
.grade-item,
.grade-footer,
.cancel-btn {
  display: none;
}

/* 移除输入框默认样式 */
input {
  outline: none;
  -webkit-appearance: none;
}

/* 禁用输入框自动填充背景色 */
input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px #F5F7FA inset !important;
}

.select-input {
  width: 100%;
  height: 44px;
  padding: 0 12px;
  background: #F5F7FA;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  color: #1D2129;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.placeholder {
  color: #86909C;
}

.arrow-down {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #86909C;
}

.selector-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1000;
  display: flex;
  align-items: flex-end;
}

.selector-content {
  width: 100%;
  background: #fff;
  border-radius: 16px 16px 0 0;
  overflow: hidden;
}

.selector-header {
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 500;
  color: #1D2129;
  border-bottom: 1px solid #EBEEF5;
}

.selector-list {
  max-height: 30vh;
  overflow-y: auto;
}

.selector-item {
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  color: #1D2129;
  border-bottom: 1px solid #EBEEF5;
}

.selector-item:active {
  background: #F5F7FA;
}

.selector-footer {
  padding: 16px;
}

.selector-footer button {
  width: 100%;
  height: 44px;
  background: #fff;
  border: 1px solid #4080FF;
  border-radius: 8px;
  color: #4080FF;
  font-size: 15px;
}

.select-input-disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.search-btn-disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: #86909C;
}

.footer {
  position: absolute;
  /* 改为绝对定位 */
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 16px 0;
  text-align: center;
  background: #F5F7FA;
}

.footer p {
  font-size: 12px;
  color: #86909C;
  line-height: 1.5;
}

.page-title {
  margin-top: 46px;
  text-align: center;
}

.page-title h2 {
  font-size: 20px;
  font-weight: 500;
  color: #1D2129;
  line-height: 1.4;
}
</style>
